{
  "titles": {
    "appointmentDetailsHaveChanged": "預約詳細資料已變更",
    "appointmentScheduled": "預約已排定",
    "appointmentConfirmed": "預約已確認",
    "appointmentRequested": "已申請預約",
    "missedAppointment": "錯過預約",
    "recurringAppointmentSeriesCreated": "已建立週期性預約系列",
    "truckArrivedAtFacility": "貨車已抵達設施",
    "appointmentIsInProgressAtFacility": "預約正在設施作業中",
    "appointmentRescheduled": "預約已重新安排",
    "appointmentCompleted": "預約已完成",
    "appointmentCancelled": "預約已取消",
    "appointmentTagged": "預約已加上標籤",
    "assetReadyForPickup": "資產可取貨"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "預約詳細資料已變更",
    "appointmentScheduled": "已在 {orgName} - {warehouseName} 排定預約",
    "appointmentConfirmed": "已在 {orgName} - {warehouseName} 確認預約",
    "appointmentRequested": "已向 {orgName} - {warehouseName} 申請預約",
    "missedAppointment": "錯過在 {orgName} - {warehouseName} 的預約",
    "recurringAppointmentSeriesCreated": "已建立週期性預約系列",
    "truckArrivedAtFacility": "貨車已抵達 {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "在 {orgName} - {warehouseName} 的預約正在作業中",
    "appointmentRescheduled": "已重新安排在 {orgName} - {warehouseName} 的預約",
    "appointmentCompleted": "在 {orgName} - {warehouseName} 的預約已完成",
    "appointmentCancelled": "已取消與 {orgName} - {warehouseName} 的預約",
    "appointmentTagged": "預約已標記為 {tagName} - {warehouseName}",
    "assetReadyForPickup": "可取貨 - 貨櫃 {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "請查看下方的地點、日期、時間及所有詳細資料。",
    "appointmentScheduled": "請查看下方的地點、日期、時間及所有詳細資料。",
    "appointmentConfirmed": "請查看下方的地點、日期、時間及所有詳細資料。",
    "appointmentRequested": "請等候倉庫確認。",
    "missedAppointment": "承運商未依預約到場。",
    "recurringAppointmentSeriesCreated": "請查看下方的週期性預約詳細資料。",
    "truckArrivedAtFacility": "請查看下方的狀態與預約詳細資料。",
    "appointmentIsInProgressAtFacility": "請查看下方的狀態與預約詳細資料。",
    "appointmentRescheduled": "請查看下方的狀態與預約詳細資料。",
    "appointmentCompleted": "請查看下方的狀態與預約詳細資料。",
    "appointmentCancelled": "請查看所有詳細資料及取消原因。",
    "appointmentTagged": "請查看下方的標籤名稱與資訊。",
    "assetReadyForPickup": "您設施中的一項資產已可取貨。"
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "檢視預約",
    "appointmentScheduled": "檢視預約",
    "appointmentConfirmed": "檢視預約",
    "appointmentRequested": "檢視預約",
    "missedAppointment": "檢視預約",
    "recurringAppointmentSeriesCreated": "檢視原始預約",
    "truckArrivedAtFacility": "檢視預約",
    "appointmentIsInProgressAtFacility": "檢視預約",
    "appointmentRescheduled": "檢視預約",
    "appointmentCompleted": "檢視預約",
    "appointmentCancelled": "檢視預約",
    "appointmentTagged": "檢視預約",
    "assetReadyForPickup": "檢視預約"
  },
  "descriptions": {
    "appointmentTagged": "使用「預約標籤」設定來個別啟用標籤"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "預約取貨",
      "idLabel": "確認號碼",
      "ownedByLabel": "擁有者：",
      "pickupScheduledForLabel": "取貨排定時間：",
      "noPickupScheduledLabel": "尚未排定取貨預約",
      "storeLabel": "門市",
      "openInGoogleMapsLabel": "在 Google 地圖中開啟",
      "appointmentDetailsLabel": "預約詳細資料",
      "loadTypeLabel": "貨物類型",
      "warehouseInstructionsLabel": "倉庫指示說明",
      "amenitiesLabel": "可用設施",
      "ppeRequirementsLabel": "個人防護裝備（PPE）與其他要求",
      "dockDoorLabel": "月台門",
      "dockInstructionsLabel": "月台指示說明",
      "carrierContactLabel": "承運商聯絡人"
    }
  }
}
